import React from 'react';

// Styles
import './QsgStepTemplate.scss';

type Props = {
  title: React.ReactNode;
  description?: string;
  children: React.ReactNode;
};

const QsgStepTemplate = ({ title, description, children }: Props) => {
  const baseClassName = 'QsgStepTemplate';

  return (
    <div className={baseClassName}>
      {title}
      <div className={`${baseClassName}__content`}>
        {description && <p className={`${baseClassName}__content__description`}>{description}</p>}
        {children}
      </div>
    </div>
  );
};

export default QsgStepTemplate;
